"use client"
import React, { useEffect, useState } from "react";
import banner_bg_image from '../../Assets/images/home/banner_bg_image.svg'
import video from '../../Assets/video/home_banner_video4.mp4'
import { motion } from 'framer-motion'
import './Hero.css'
import {
  motionVariantsLeft,
  motionVariantsRight,
  motionVariantsBounceIn,
  motionVariantsBounceOut,
  motionVariantsCardFlip,
  motionProperties,
  motionPropertiesLongTime
} from '../../Components/Common/MotionVarients';


export const Hero = () => {

  return (
    <div className="xl:pt-[200px] lg:pt-[250px] md:pt-[100px] py-10 md:pb-[100px] flex items-center md:px-20 px-6 overflow-hidden"
      style={{
        backgroundImage: `url(${banner_bg_image})`,
        backgroundPosition: "left bottom",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: 'fixed'
      }}
    >

      <div className="grid lg:grid-cols-2 md:grid-cols-1 lg:gap-0 gap-10 items-center lg:text-left text-center w-full ">
        <div>
          <div className="xl:text-6xl lg:text-4xl md:text-3xl text-xl font-extrabold tracking-wider flex flex-col lg:gap-4 gap-1" >
            <motion.h1 variants={motionVariantsBounceIn} {...motionProperties} > Empowering Careers Through </motion.h1>
            <motion.h1 variants={motionVariantsLeft} {...motionProperties} className="text-primaryOrangeColor" > Cutting-Edge Education </motion.h1>
            <motion.h1 variants={motionVariantsRight} {...motionProperties} > and <b className="text-[#7a96bd]">World-Class Job Placement</b> </motion.h1>
          </div>

          {/* <motion.h1
            variants={motionVariantsLeft}
            {...motionProperties}
            className="lg:text-6xl md:text-3xl text-xl  font-extrabold tracking-wider lg:w-[90%]">
            We Provide <span className="text-primaryOrangeColor">Modern Education</span> & <span className="text-[#7a96bd]">Best Jobs</span> in the World
          </motion.h1> */}
          <p className="text-secondaryTextColor font-medium mt-4">

            Accelerate Your Future in Just Eight Weeks
          </p>
          {/* <div id="container">
            <img src="https://media.tenor.com/GocCvG7hs78AAAAi/rocket-joypixels.gif" alt="" className="w-full" />
          </div> */}
        </div>
        <div className="flex items-center justify-center relative">
          <motion.div
            variants={motionVariantsCardFlip}
            {...motionPropertiesLongTime}
            className="p-4 bg-white rounded-full">
            <div className="xl:h-[450px] xl:w-[450px] md:h-[350px] md:w-[350px] h-[250px] w-[250px] bg-white rounded-full flex items-center overflow-hidden">
              <video
                className='w-[full] h-[full] scale-[1.8]'
                src={video}
                title=""
                autoPlay
                muted
                loop
              ></video>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};
